/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontProfilesStatus = "DELETED" | "LIVE" | "REJECTED" | "UNDER_REVIEW" | "WORK_IN_PROGRESS" | "%future added value";
export type PdpSharedDescriptionAboutMaker_item$ref = any;
export type PdpSharedDescriptionAboutMaker_item = {
    readonly seller: {
        readonly isMakerOrManufacturer: boolean | null;
        readonly sellerProfile: {
            readonly company: string | null;
        } | null;
        readonly sellerPreferences: {
            readonly urlLabel: string | null;
        } | null;
        readonly liveStorefrontProfile: {
            readonly status: StorefrontProfilesStatus | null;
            readonly aboutUs: string | null;
            readonly photos: ReadonlyArray<{
                readonly path: string | null;
                readonly type: {
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedDescriptionAboutMaker_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAboutMaker_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isMakerOrManufacturer",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "sellerProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "company",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "sellerPreferences",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerPreferences",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "liveStorefrontProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "aboutUs",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": null,
              "args": null,
              "concreteType": "Photo",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "type",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PhotoType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '42a7806cf52d000f2dca97cfd74964fd';
export default node;
